import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/settings/tools/new/page';

export const Route = createFileRoute('/_app/settings/tools/new/')({
  component: Page,
});
